import { Injectable } from '@angular/core';
import { FilterableService } from '../filterable-service';

@Injectable()
export class WorkOrdersFilterService {
    lookupDataObjects: any;
    programs: any;
    searchCriteria: any;

    lookupData = {
        Architectures: new FilterableService(),
        Areas: new FilterableService(),
        AssignedEngineers: new FilterableService(),
        Deliverables: new FilterableService(),
        ErgoEngineers: new FilterableService(),
        Gates: new FilterableService(),
        Mboms: new FilterableService(),
        MELeads: new FilterableService(),
        MEs: new FilterableService(),
        PIEs: new FilterableService(),
        Plants: new FilterableService(),
        PLLs: new FilterableService(),
        Programs: new FilterableService(),
        Regions: new FilterableService(),
        Requestors: new FilterableService(),
        RequestTypes: new FilterableService(),
        SMT1s: new FilterableService(),
        SMT2s: new FilterableService(),
        SMT3s: new FilterableService(),
        Statuses: new FilterableService(),
        StudyTitles: new FilterableService(),
        TotalVehicleNumbers: new FilterableService(),
        TrackingVehicleNumbers: new FilterableService(),
        VELeads: new FilterableService(),
        WeldEngineers: new FilterableService(),
        WorkOrders: new FilterableService(),
        Zones: new FilterableService(),
    };

    constructor() { 
        //this is kept empty on purpose
    }

    public get getLookupData(): any {
        return this.lookupData;
    }

    mapLookupData(lookup: any) {
        Object.keys(lookup).forEach(k => {
            const lookupService = this.lookupData[k];
            const data = lookup[k];
            if (lookupService && data) {
                if (k === 'Requestors' || k === 'VELeads' || k === 'AssignedEngineers') {
                    lookupService.next(data.map(x => x.Value).filter(x => x));
                } else {
                    lookupService.next(data.map(x => x.Name).filter(x => x));
                }
            }
        });
    }

    mapBodyFilters(gridFilter: any): any {
        const _filters: any = {};
        const plantIds: any[] = [];
        const statusIds: any[] = [];
        const veEngineers: any[] = [];
        const veLeads: any[] = [];
        const programs: any[] = [];
        const requestTypes: any[] = [];
        const deliverables: any[] = [];
        const requestors: any[] = [];
        const gates: any[] = [];
        const tkvs: any[] = [];
        const mBoms: any[] = [];

        flatten(gridFilter).map(f => {
            const _field: string = f.field;
            const _values = f.value.toString().split(',').map(x => x.trim());
            const lookupData = (_field === 'RequestorName' || _field === 'AssignedEngineerName' || _field === 'VELeadName')
                ? this.getLookupDataForField(_field).filter(x => x.Value === _values[0])
                : this.getLookupDataForField(_field).filter(x => x.Name === _values[0]);

            // Set text input filters
            this.buildFilterDto(_field, _values[0], _filters);
            delete _filters.ProgramLike; // For Body WO, Program is filtered by multiselect, not text input

            // Set date filters
            this.setDateFilter(_field, _filters, f);

            // Set multiselect filters
            this.setPlantFilter(plantIds, _field, _filters, lookupData);
            this.setStatusFilter(statusIds, _field, _filters, lookupData);
            this.setProgramFilter(programs, _field, _filters, lookupData);
            this.setRequestTypesFilter(requestTypes, _field, _filters, lookupData);
            this.setDeliverablesFilter(deliverables, _field, _filters, lookupData);
            this.setGateFilter(gates, _field, _filters, lookupData);
            this.setTKVFilter(tkvs, _field, _filters, lookupData);
            this.setMBOMFilter(mBoms, _field, _filters, lookupData);
            this.setVEEngineerFilter(veEngineers, _field, _filters, lookupData);
            this.setVELeadFilter(veLeads, _field, _filters, lookupData);
            this.setRequestorFilter(requestors, _field, _filters, lookupData);
        });

        return _filters;
    }

    mapGAFilters(gridFilter: any): any {
        const _filters: any = {};
        const plantIds: any[] = [];
        const statusIds: any[] = [];
        const veEngineers: any[] = [];
        const veLeads: any[] = [];
        const requestors: any[] = [];
        if(this.lookupDataObjects){
            this.lookupDataObjects.StudyTitles = [];
        } 

        flatten(gridFilter).map(f => {
            const _field: string = f.field;
            const _values = f.value.toString().split(',').map(x => x.trim());
            const lookupData = (_field === 'RequestorName' || _field === 'AssignedEngineerName' || _field === 'VELeadName')
                ? this.getLookupDataForField(_field).filter(x => x.Value === _values[0])
                : this.getLookupDataForField(_field).filter(x => x.Name === _values[0]);

            // Set text input filters
            this.buildFilterDto(_field, _values[0], _filters);

            // Set dropdown (single select) filters
            if (_field === Fields.GateDescription && lookupData[0]) {
                _filters.GateId = [lookupData[0].Value];
            }

            // Set date filters
            this.setDateFilter(_field, _filters, f);

            // Set multiselect filters
            this.setPlantFilter(plantIds, _field, _filters, lookupData);
            this.setStatusFilter(statusIds, _field, _filters, lookupData);
            this.setVEEngineerFilter(veEngineers, _field, _filters, lookupData);
            this.setVELeadFilter(veLeads, _field, _filters, lookupData);
            this.setRequestorFilter(requestors, _field, _filters, lookupData);
        });

        return _filters;
    }

    getReportFilters(filters: any): any {
        filters.AssignedOnly = null;
        filters.UnAssignedOnly = null;
        filters.ProgramId = this.programs;
        return filters;
    }

    getSearchFilters(filters: any, userModule: string): any {
        filters.AssignedOnly = null;
        filters.UnAssignedOnly = null;

        if (!filters.AssignedEngineer) { filters.AssignedEngineer = this.searchCriteria.AssignedEngineer ? [this.searchCriteria.AssignedEngineer] : null; }
        if (!filters.PlantId) { filters.PlantId = this.searchCriteria.PlantId ? [this.searchCriteria.PlantId] : null; }
        if (!filters.ProgramId) { filters.ProgramId = this.searchCriteria.ProgramId ? [this.searchCriteria.ProgramId] : null; }
        filters.TextSearch = this.searchCriteria.TextSearch ? this.searchCriteria.TextSearch : null;

        if (userModule === 'VE_Body') {
            this.getBodySearchFilters(filters);
        } else {
            this.getGASearchFilters(filters);
        }

        return filters;
    }

    /**
     *
     * @param field - return the lookup data for the given column (i.e., field)
     * Only needed for those columns in which the filtering is done via a dropdown or multiselect
     */
    getLookupDataForField(field: string): any[] {
        switch (field) {
            case Fields.ProgramCode: return this.lookupDataObjects.Programs;
            case Fields.PlantDescription: return this.lookupDataObjects.Plants;
            case Fields.GateDescription: return this.lookupDataObjects.Gates;
            case Fields.Status: return this.lookupDataObjects.Statuses;
            case Fields.StudyTitleDescription: return this.lookupDataObjects.StudyTitles;
            case Fields.VELeadName: return this.lookupDataObjects.VELeads;
            case Fields.AssignedEngineerName: return this.lookupDataObjects.AssignedEngineers;
            case Fields.RequestTypeDescription: return this.lookupDataObjects.RequestTypes;
            case Fields.DeliverablesDescription: return this.lookupDataObjects.Deliverables;
            case Fields.RequestorName: return this.lookupDataObjects.Requestors;
            case Fields.TrackingVehicleNumberDescription: return this.lookupDataObjects.TrackingVehicleNumbers;
            case Fields.MbomDescription: return this.lookupDataObjects.Mboms;
            default: return [];
        }
    }

    private getBodySearchFilters(filters: any) {
        if (!filters.Requestor) { filters.Requestor = this.searchCriteria.Requestor ? [this.searchCriteria.Requestor] : null; }
        if (!filters.DeliverableId) { filters.DeliverableId = this.searchCriteria.DeliverableId ? [this.searchCriteria.DeliverableId] : null; }
    }

    private getGASearchFilters(filters: any) {
        filters.ME = this.searchCriteria.ME ? [this.searchCriteria.ME] : null;
        filters.ErgoEngineer = this.searchCriteria.ErgoEngineer ? [this.searchCriteria.ErgoEngineer] : null;
        filters.ArchitectureId = this.searchCriteria.ArchitectureId ? [this.searchCriteria.ArchitectureId] : null;
        if (!filters.GateId) { filters.GateId = this.searchCriteria.GateId ? [this.searchCriteria.GateId] : null; }
        if (!filters.StatusId) { filters.StatusId = this.searchCriteria.StatusId ? [this.searchCriteria.StatusId] : null; }
        filters.SMT1Id = this.searchCriteria.SMT1Id ? [this.searchCriteria.SMT1Id] : null;
        filters.SMT2Id = this.searchCriteria.SMT2Id ? [this.searchCriteria.SMT2Id] : null;
        filters.SMT3Id = this.searchCriteria.SMT3Id ? [this.searchCriteria.SMT3Id] : null;
        filters.ToolingOperatorInterfaceId = this.searchCriteria.ToolingOperatorInterfaceId ? [this.searchCriteria.ToolingOperatorInterfaceId] : null;
    }

    private setDateFilter(_field: any, _filters: any, object: any) {
        if (_field.toLowerCase().includes('date') && object.operator) {
            const datePrefix = object.operator === 'gte' ? 'From' : 'To';
            _filters[`${datePrefix}${object.field}`] = object.value;
        }
    }

    private setPlantFilter(plantIds, _field: any, _filters: any, lookupData: any[]) {
        plantIds.push((_field === Fields.PlantDescription && lookupData[0]) ? lookupData[0].Value : undefined);
        const items = plantIds.filter(x => x !== undefined);
        _filters.PlantId = items.length > 0 ? items : null;
    }

    private setProgramFilter(programs, _field: any, _filters: any, lookupData: any[]) {
        programs.push((_field === Fields.ProgramCode && lookupData[0]) ? lookupData[0].Value : undefined);
        const items = programs.filter(x => x !== undefined);
        _filters.ProgramId = items.length > 0 ? items : null;
    }

    private setRequestTypesFilter(requestTypes, _field: any, _filters: any, lookupData: any[]) {
        requestTypes.push((_field === Fields.RequestTypeDescription && lookupData[0]) ? lookupData[0].Value : undefined);
        const items = requestTypes.filter(x => x !== undefined);
        _filters.RequestTypeId = items.length > 0 ? items : null;
    }

    private setDeliverablesFilter(deliverables, _field: any, _filters: any, lookupData: any[]) {
        deliverables.push((_field === Fields.DeliverablesDescription && lookupData[0]) ? lookupData[0].Value : undefined);
        const items = deliverables.filter(x => x !== undefined);
        _filters.DeliverableId = items.length > 0 ? items : null;
    }

    private setGateFilter(gates, _field: any, _filters: any, lookupData: any[]) {
        gates.push((_field === Fields.GateDescription && lookupData[0]) ? lookupData[0].Value : undefined);
        const items = gates.filter(x => x !== undefined);
        _filters.GateId = items.length > 0 ? items : null;
    }

    private setTKVFilter(tkvs, _field: any, _filters: any, lookupData: any[]) {
        tkvs.push((_field === Fields.TrackingVehicleNumberDescription && lookupData[0]) ? lookupData[0].Value : undefined);
        const items = tkvs.filter(x => x !== undefined);
        _filters.TrackingVehicleNumberId = items.length > 0 ? items : null;
    }

    private setMBOMFilter(mBoms, _field: any, _filters: any, lookupData: any[]) {
        mBoms.push((_field === Fields.MbomDescription && lookupData[0]) ? lookupData[0].Value : undefined);
        const items = mBoms.filter(x => x !== undefined);
        _filters.MbomId = items.length > 0 ? items : null;
    }

    private setStatusFilter(statusIds, _field: any, _filters: any, lookupData: any[]) {
        statusIds.push((_field === Fields.Status && lookupData[0]) ? lookupData[0].Value : undefined);
        const items = statusIds.filter(x => x !== undefined);
        _filters.StatusId = items.length > 0 ? items : null;
    }

    private setVEEngineerFilter(veEngineers, _field: any, _filters: any, lookupData: any[]) {
        veEngineers.push((_field === Fields.AssignedEngineerName && lookupData[0]) ? lookupData[0].Name : undefined);
        const items = veEngineers.filter(x => x !== undefined);
        _filters.AssignedEngineer = items.length > 0 ? items : null;
    }

    private setVELeadFilter(veLeads, _field: any, _filters: any, lookupData: any[]) {
        veLeads.push((_field === Fields.VELeadName && lookupData[0]) ? lookupData[0].Name : undefined);
        const items = veLeads.filter(x => x !== undefined);
        _filters.VELead = items.length > 0 ? items : null;
    }

    private setRequestorFilter(requestors, _field: any, _filters: any, lookupData: any[]) {
        requestors.push((_field === Fields.RequestorName && lookupData[0]) ? lookupData[0].Name : undefined);
        const items = requestors.filter(x => x !== undefined);
        _filters.Requestor = items.length > 0 ? items : null;
    }

    private buildFilterDto(field: string, value: any, _filters) {
        switch (field) {
            case Fields.ProgramCode:
                _filters.ProgramLike = value;
                break;

            case Fields.WorkOrderNumber:
                _filters.WorkOrderNumberLike = value;
                break;

            case Fields.StudyTitleDescription:
                _filters.StudyTitleLike = value;
                break;

            case Fields.WorkOrderComments:
                _filters.WorkOrderCommentsLike = value;
                break;

            case Fields.GateTargeted:
                _filters.GateTargeted = value;
                break;

            case Fields.MfgStudyTitle:
                _filters.MfgStudyTitleLike = value;
                break;

            case Fields.StudyName:
                _filters.StudyNameLike = value;
                break;

            default:
                break;
        }
    }
}

const flatten = filter => {
    const filters = (filter || {}).filters;
    if (filters) {
        return filters.reduce(
            (acc, curr) => acc.concat(curr.filters ? flatten(curr) : [curr]),
            []
        );
    }
    return [];
};

enum Fields {
    ProgramCode = 'ProgramCode',
    PlantDescription = 'PlantDescription',
    GateDescription = 'GateDescription',
    Status = 'Status',
    StudyTitleDescription = 'StudyTitleDescription',
    VELeadName = 'VELeadName',
    AssignedEngineerName = 'AssignedEngineerName',
    RequestTypeDescription = 'RequestTypeDescription',
    DeliverablesDescription = 'DeliverablesDescription',
    RequestorName = 'RequestorName',
    TrackingVehicleNumberDescription = 'TrackingVehicleNumberDescription',
    MbomDescription = 'MbomDescription',
    WorkOrderNumber = 'WorkOrderNumber',
    WorkOrderComments = 'WorkOrderComments',
    GateTargeted = 'GateTargeted',
    MfgStudyTitle = 'MfgStudyTitle',
    StudyName = 'StudyName'
}
